import { combineReducers } from 'redux';
import list from './List/reducer';
import select from './Select/reducer';
import create from './Create/reducer';
import edit from './Edit/reducer';

const categoriesReducer = combineReducers({
  list,
  create,
  edit,
  select,
});

export default categoriesReducer;
